var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareTabAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "svg-share-audio-a",
    d: "M12 3v9.28a4.39 4.39 0 0 0-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 43,
    x: 1,
    y: 1,
    stroke: "var(--svg-bg-color)",
    strokeOpacity: "var(--svg-bg-opacity)",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "svg-share-audio-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-share-audio-a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    mask: "url(#svg-share-audio-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-13-13h50v50h-50Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTabAudio);
export default __webpack_public_path__ + "static/media/share-tab-audio.8648b7f3004f1f14d4233de71b50419e.svg";
export { ForwardRef as ReactComponent };